import { Component, OnInit } from '@angular/core';
import { DataService } from '../../../services/data/data.service';
import { obtenerError, Perspectivas, Planificacion } from '../../../models/Formulacion/indicadores-metas/datos';
import { ExcelService } from '../../../services/excel/excel.service';
import { FormControl, FormGroup, ValidatorFn, Validators } from '@angular/forms';
import { PerspectivasService } from '../../../services/formulacion/perspectivas/perspectivas.service';
import Swal from 'sweetalert2';
import { firstValueFrom } from 'rxjs';
import { CookieService } from 'ngx-cookie-service';
import { messages } from '../../funciones/mensajes';
import { TranslateService } from '@ngx-translate/core';
import moment from 'moment';

import { PlanificacionService } from '../../../services/gestion/planificacion/planificacion.service';
import { PerspectivaService } from '../../../services/gestion/perspectivas/perspectiva.service'; 
import { ModalComponent } from '../../../components/modal/modal.component';
import { PERMISOS } from '../../../shared/catalogos';

@Component({
  selector: 'app-perspectiva',
  templateUrl: './perspectiva.component.html',
  styleUrl: './perspectiva.component.css'
})
export class PerspectivaComponent implements OnInit {
  public readonly permisos = PERMISOS;

  public planeacion: Planificacion[] = [];
  public perspectiva: Perspectivas[] = [];

  public idper: number = 0;
  private idPlanificacion: any;

  private perpectivaa: any; //para el edit
  public modalAgregar = false;
  public modalEditar = false;
  public viewTablero = false;
  public skeletons = ['','','']


  /** Grupo de validación de datos */
  formEdit = new FormGroup({ 
    inputName: new FormControl('', [Validators.required]),
    inputDescription: new FormControl('', [Validators.required]),
  },{ validators: this.nombreDuplicidad() });

  formNuevo = new FormGroup({ 
    inputName: new FormControl('', [Validators.required]),
    inputDescription: new FormControl('', [Validators.required]),
  },{ validators: this.nombreDuplicidad() });
   
  private valueDefault = {
    inputName: '',
    inputDescription: ''
  };

  FormNew = false;
  FormEdit = false;

  constructor(
    public dataService: DataService,
    // private perspectivasService: PerspectivasService,
    private excelService: ExcelService,
    private cookies: CookieService,
    private translate: TranslateService,

    private planificacionService: PlanificacionService,
    private perspectivaService: PerspectivaService,
  ){
    this.obtData();
  }

  ngOnInit(): void { }

  /** Obtención de los datos */
  public async obtData(){
    try {
      //obtener el valor de las cookies
      const planeacionId = this.cookies.get('idInstitucion');
      const plan = await this.planificacionService.getPlanificacionByIdGQL(Number(planeacionId));

      if (!plan) {
        return;
      }

      this.planeacion = [{
        id: plan['id'],
        nombre: plan['name'],
        fecha_inicio: moment(plan['initial_date']).toDate(),
        fecha_fin: moment(plan['end_date']).toDate(),
        institucionId: plan['institution'].id,
        isActive: plan['isActive']
      }];

      this.idPlanificacion = Number(plan['id']);
  
      const perspectivas = plan.perspectives;
  
      this.perspectiva = perspectivas
        .map(per => ({
          nombre: per.name,
          descripcion: per.description,
          planningId: plan.id,
          id: per.id
        }));
  
      this.perspectiva = this.ordenarPerspe(this.perspectiva);
      this.viewTablero = true;

    } catch (error) {
      return;
    }
  }


  private ordenarPerspe(array: any){
    array.sort(function(a: any, b: any){
      if(Number(a.id) > Number(b.id)){
        return 1;
      }
      if(Number(a.id) < Number(b.id)){
        return -1;
      }
      return 0;
    });
    return array;
  }

  /** Apertura de los modales */
  public abrirFormAgregar(perspe: any) {
    // Reiniciar formulario y estados
    this.formNuevo.reset(this.valueDefault);
    this.idper = perspe.id;
    this.FormNew = true;
    // document.getElementById('formularionuevo')!.style.display = 'block';
  }

  public abrirForm(perspe: any){
    this.perpectivaa = perspe;
    this.idper = perspe.id;
    this.formEdit.controls['inputName'].setValue(this.perpectivaa.nombre);
    this.formEdit.controls['inputDescription'].setValue(this.perpectivaa.descripcion);
    this.FormEdit = true;
  }

  /** Cerrar modales */
  public cerrarForm(){
    this.FormNew = false;
    this.FormEdit = false;
    this.formNuevo.reset(this.valueDefault);
    this.formEdit.reset(this.valueDefault);
  }


  /** Exportación de archivos */
  public exportar_excel(){
    const title = this.translate.instant('gestion.formulacion.perspectivas.tituloExcel');
    const header = [
      this.translate.instant('gestion.formulacion.perspectivas.formText1'),
      this.translate.instant('gestion.formulacion.perspectivas.formText6')
    ]
    let rows = [];
    let cols = [];
    for(var i = 0; i < this.perspectiva.length; i++){
      cols.push(this.perspectiva[i].nombre);
      cols.push(this.perspectiva[i].descripcion);
      rows.push(cols);
      cols = [];
    }
    this.excelService.generateExcelPerspectivas(title,header, rows, 'Perspectivas');
    
  }
  
  /** Almacenado de datos y recarga de estos */
  public async almacenarDatos() {
    if (this.formNuevo.invalid) return;
  
    const perspectiva = new Perspectivas();
    perspectiva.nombre = this.formNuevo.get('inputName')?.value;
    perspectiva.descripcion = this.formNuevo.get('inputDescription')?.value;
    perspectiva.planningId = this.idPlanificacion;
  
    try {
      await firstValueFrom(this.perspectivaService.postPerspectivas(perspectiva));
      await this.refrescarPerspectivas();
      
      messages.succesMessageGraph(this.translate.instant('gestion.formulacion.perspectivas.infoAgregada'));
      
      this.modalAgregar = false;
      this.cerrarForm();
    } catch (error) {
      const errMsg = obtenerError.errorObt(error?.error?.message);
      messages.errorMessageGraph(errMsg);
    }
  }
  
  public async almacenarDatosEdit() {
    if (this.formEdit.invalid) return;
  
    this.perpectivaa.nombre = this.formEdit.get('inputName')?.value;
    this.perpectivaa.descripcion = this.formEdit.get('inputDescription')?.value;
  
    try {
      await firstValueFrom(this.perspectivaService.patchPerspectivas(this.perpectivaa));
      await this.refrescarPerspectivas();

      messages.succesMessageGraph(this.translate.instant('gestion.formulacion.perspectivas.infoActualizada'));

      this.modalEditar = false;
      this.cerrarForm();
    } catch (error) {
      const errMsg = obtenerError.errorObt(error?.error?.message);
      messages.errorMessageGraph(errMsg);
    }
  }

  private async refrescarPerspectivas() {
    const planeacionId = this.cookies.get('idInstitucion');
    const plan = await this.planificacionService.getPlanificacionByIdGQL(Number(planeacionId));
    const perspectivas = plan.perspectives;
  
    this.perspectiva = perspectivas
      .map(per => ({
        nombre: per.name,
        descripcion: per.description,
        planningId: plan.id,
        id: per.id
      }));

    this.perspectiva = this.ordenarPerspe(this.perspectiva);
  }


  /** Metodos de decición de guardado */
  public alertas(aler: any){
    if(aler === 'editar'){
      this.almacenarDatosEdit();
    }else if(aler === 'guardar'){
      this.almacenarDatos();
    }
  }

  /** Metodo de eliminación */
  public async eliminar(perspe: any){
    try {
      await firstValueFrom(this.perspectivaService.deletePer(perspe));
      await this.refrescarPerspectivas();
      // Mensaje exito
      messages.succesMessageGraph(this.translate.instant('gestion.formulacion.perspectivas.infoEliminada'));
    } catch (err) {
      if(err.status === 500){
        messages.infoMessageGraph(this.translate.instant('gestion.formulacion.perspectivas.noEliminar'));
        return;
      }
      let er = obtenerError.errorObt(err['error'].message);
      messages.errorMessageGraph(er);
    }
  }


  /** Control del boton guardar para campos obligatorios */
  public puede_guardar(){
    var perspectiv = new Perspectivas();
    perspectiv.nombre = this.formNuevo.get('inputName')?.value;
    if(perspectiv.nombre !== undefined && perspectiv.nombre !== '' && !this.nombreExiste()){
      return ''
    }
    return 'w3-disabled'
  }

  public puede_guardarEdit(){
    var perspectiv = new Perspectivas();
    perspectiv.nombre = this.formEdit.get('inputName')?.value;
    if(perspectiv.nombre !== '' && !this.nombreExiste()){
      return ''
    }
    return 'w3-disabled'
  }

  public clickFuera(event, modal){
    if (event.target === document.getElementById(modal)) {
      document.getElementById(modal).classList.add('moveShake');
      setTimeout(() => {
        document.getElementById(modal).classList.remove('moveShake');
      },600);
    }
  }

  /** Comprobación de que el nombre no exista*/
  private nombreDuplicidad(): ValidatorFn {
    return (fg: FormGroup) => {
      const nombre = fg.get('inputName')!.value?.toString().trim().toLowerCase();
      if (!nombre) return null;

      const existe = this.perspectiva.some(el => {
        const otro = el.nombre.trim().toLowerCase();
        if (this.formEdit) {
          return (otro === nombre && Number(el.id) !== Number(this.perpectivaa.id));
        } else {
          return otro === nombre;
        }
      });

      return existe ? { isValid: true } : null;
    };
  }
  public nombreExiste(): boolean {
    if (this.FormNew) {
      return this.formNuevo.hasError('isValid');
    } else if (this.FormEdit) {
      return this.formEdit.hasError('isValid');
    }
    return false;
  }
  
}
